export interface IPremiumTerm {
  code: string;
  description: string;
  min: number,
  max: number,
  applicableForCI: number
}

export const PremiumTerms: IPremiumTerm[] = [
  {
    code: '5',
    description: '5 years',
    min: 19, 
    max: 65,
    applicableForCI: 60,
  },
  {
    code: '20',
    description: '20 years',
    min: 19, 
    max: 65,
    applicableForCI: 45,

  },
  {
    code: '65',
    description: 'Up to 65 Age Next Birthday',
    min: 19, 
    max: 60,
    applicableForCI: 60,
  }
]